import React from 'react'
import Button from '@Components/Buttons/Button'

export interface ConfirmationStepProps {
    createWork(): void
    closeSidebar(): void
    isInternal: boolean
    disableButton?: boolean
    isOverclaim?: boolean
}
const ConfirmationStep = (props: ConfirmationStepProps) => {
    const { createWork, closeSidebar, isInternal, disableButton } = props

    return (
        <div className="warning-edit-work-popup">
            <h3>Confirm Submission</h3>
            <p>
                Click <strong>Submit</strong> to submit this work to The MLC.
                <br />
                <br />
                To review or edit any information, click <strong>Back</strong>.
            </p>

            <div className="links-block">
                <Button mainColor type="secondary" onClick={closeSidebar}>
                    Back
                </Button>
                <Button mainColor type="primary" disabled={disableButton || isInternal} onClick={createWork}>
                    Submit
                </Button>
            </div>
        </div>
    )
}

export default ConfirmationStep
